import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation UnblockUser($blockeeId: String!) {
    unblockUser(blockeeId: $blockeeId) {
      success
      message
    }
  }
`

export interface UnblockUserInput {
  blockeeId: string
}

export interface UnblockUserOutput {
  unblockUser: {
    success: boolean
    message: string
  }
}

export const useUnblockUser = () => useMutation<UnblockUserOutput, UnblockUserInput>(mutation)
